"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Remove an Adjustment from an order.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type RemoveOrderAdjustments
 * @param prevState
 */
function default_1(event, prevState) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    const adjustmentTypeToRemove = event.adjustmentType;
    const adjustmentIdsToRemove = event.adjustmentIds;
    const adjustmentIdsToRemoveForItems = event.orderItemAdjustmentIds;
    const orderItemIds = event.orderItemIds;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    if (adjustmentTypeToRemove || (adjustmentIdsToRemove === null || adjustmentIdsToRemove === void 0 ? void 0 : adjustmentIdsToRemove.length)) {
        order.adjustments = (_a = order.adjustments) === null || _a === void 0 ? void 0 : _a.filter(a => (adjustmentTypeToRemove &&
            a.adjustmentType !== adjustmentTypeToRemove) ||
            ((adjustmentIdsToRemove === null || adjustmentIdsToRemove === void 0 ? void 0 : adjustmentIdsToRemove.length) &&
                !adjustmentIdsToRemove.includes(a.id)));
    }
    order.orderItems.forEach(orderItem => {
        var _a;
        if ((orderItemIds === null || orderItemIds === void 0 ? void 0 : orderItemIds.length) && (orderItemIds === null || orderItemIds === void 0 ? void 0 : orderItemIds.includes(orderItem.id))) {
            orderItem.adjustments = [];
        }
        else {
            orderItem.adjustments = (_a = orderItem.adjustments) === null || _a === void 0 ? void 0 : _a.filter(a => (adjustmentIdsToRemoveForItems === null || adjustmentIdsToRemoveForItems === void 0 ? void 0 : adjustmentIdsToRemoveForItems.length)
                ? !adjustmentIdsToRemoveForItems.includes(a.id)
                : a.adjustmentType !== event.adjustmentType);
        }
        orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
        orderItem.surchargeAmount = (0, computePrice_1.computeOrderItemSurcharge)(orderItem);
    });
    return { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
}
exports.default = default_1;
//# sourceMappingURL=removeAdjustments.js.map